module.exports = __webpack_public_path__ + "img/ai2.f0e6dd43.png";